import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { SmartLink } from "../lib/navLink.jsx";

/**
 * News/updates card grid — mirrors AWS "What's New" section.
 * section props: id, kicker, title, viewAllLabel, viewAllHref,
 *   items: [{ category, date, title, linkLabel, linkHref, iconKey }]
 */
export default function SectionNews({ section }) {
  if (!section?.items?.length) return null;
  const { id, kicker, title, viewAllLabel, viewAllHref, items } = section;

  return (
    <section className="pmp-news-section" id={id}>
      <Container>
        <div className="d-flex align-items-end justify-content-between flex-wrap gap-3 mb-4">
          <div>
            {kicker && <p className="pmp-kicker mb-1">{kicker}</p>}
            <h2 className="h3 fw-bold mb-0">{title}</h2>
          </div>
          {viewAllLabel && (
            <SmartLink href={viewAllHref || "#"} className="pmp-news-link">
              {viewAllLabel}
              <span className="bi bi-arrow-right" aria-hidden="true" />
            </SmartLink>
          )}
        </div>
        <Row className="g-4">
          {items.map((item, i) => (
            <Col key={`${item.title}-${i}`} sm={6} xl={3}>
              <div className="pmp-news-card">
                <div className="pmp-news-card-img">
                  <span
                    className={`bi ${item.iconKey ? `bi-${item.iconKey}` : "bi-newspaper"}`}
                    aria-hidden="true"
                  />
                </div>
                <div className="pmp-news-card-body">
                  {item.category && (
                    <span className="pmp-news-badge">{item.category}</span>
                  )}
                  {item.date && (
                    <div className="pmp-news-date mb-2">{item.date}</div>
                  )}
                  <div className="pmp-news-title">{item.title}</div>
                  {item.linkLabel && (
                    <SmartLink
                      href={item.linkHref || "#"}
                      className="pmp-news-link"
                    >
                      {item.linkLabel}
                      <span
                        className="bi bi-arrow-right"
                        aria-hidden="true"
                      />
                    </SmartLink>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
